<!-- Bell button with unread badge -->
<div class="bhub-notif-bell-wrap">
  <button
    type="button"
    class="bhub-notif-bell-btn"
    (click)="togglePanel($event)"
    [attr.aria-label]="store.unreadCount() > 0
      ? 'Notifications, ' + store.unreadCount() + ' unread'
      : 'Notifications, no unread'"
    [attr.aria-haspopup]="true"
  >
    <i class="pi pi-bell text-lg"></i>
    @if (store.unreadCount() > 0) {
      <span class="bhub-notif-badge" aria-hidden="true">
        {{ store.unreadCount() > 99 ? '99+' : store.unreadCount() }}
      </span>
    }
  </button>
</div>

<!-- Notifications overlay panel -->
<p-overlayPanel #panel styleClass="bhub-notif-panel p-0">
  <div class="bhub-notif-container">

    <!-- Panel header -->
    <div class="bhub-notif-header">
      <div class="bhub-notif-header-top">
        <span class="bhub-notif-title">Notifications</span>
        @if (store.unreadCount() > 0) {
          <span class="bhub-notif-unread-chip" [attr.aria-label]="store.unreadCount() + ' unread'">
            {{ store.unreadCount() }}
          </span>
        }
        <button
          type="button"
          class="bhub-notif-mark-all-btn"
          (click)="onMarkAllRead()"
          [disabled]="store.unreadCount() === 0"
          aria-label="Mark all notifications as read"
        >
          Mark all read
        </button>
      </div>

      <!-- Filter chips -->
      <div class="bhub-notif-filters" role="toolbar" aria-label="Notification filters">
        @for (f of filters; track trackFilter($index, f)) {
          <button
            type="button"
            class="bhub-notif-filter-chip"
            [class.bhub-notif-filter-chip--active]="store.activeFilter() === f.id"
            (click)="setFilter(f.id)"
            [attr.aria-pressed]="store.activeFilter() === f.id"
          >
            {{ f.label }}
          </button>
        }
      </div>
    </div>

    <!-- Notification list -->
    <div class="bhub-notif-list" role="list" aria-label="Notification list">
      @if (store.filteredItems().length === 0) {
        <div class="bhub-notif-empty" role="status" aria-label="No notifications">
          <i class="pi pi-check-circle bhub-notif-empty-icon" aria-hidden="true"></i>
          <p class="bhub-notif-empty-title">All caught up!</p>
          <p class="bhub-notif-empty-sub">No notifications match this filter.</p>
        </div>
      } @else {
        @for (notif of store.filteredItems(); track trackNotif($index, notif)) {
          <div
            class="bhub-notif-card"
            [class.bhub-notif-card--unread]="!notif.read"
            [class.bhub-notif-card--clickable]="hasTarget(notif)"
            [attr.data-type]="notif.type"
            role="listitem"
            [attr.aria-label]="notif.title + (notif.read ? '' : ', unread')"
            (click)="onRowClick(notif)"
            [attr.tabindex]="hasTarget(notif) ? 0 : -1"
            (keydown.enter)="onRowClick(notif)"
            (keydown.space)="onRowClick(notif)"
          >
            <!-- Left: type color bar + icon -->
            <div class="bhub-notif-card-icon-col" aria-hidden="true">
              <div class="bhub-notif-type-bar"></div>
              <i [class]="'pi ' + typeIcon(notif.type) + ' bhub-notif-type-icon'"></i>
            </div>

            <!-- Right: content -->
            <div class="bhub-notif-card-body">
              <div class="bhub-notif-card-top">
                <span class="bhub-notif-card-title">{{ notif.title }}</span>
                @if (!notif.read) {
                  <span class="bhub-notif-unread-dot" aria-label="Unread"></span>
                }
                @if (notif.dismissible) {
                  <button
                    type="button"
                    class="bhub-notif-dismiss-btn"
                    (click)="onDismiss($event, notif.id)"
                    [attr.aria-label]="'Dismiss: ' + notif.title"
                  >
                    <i class="pi pi-times" aria-hidden="true"></i>
                  </button>
                }
              </div>

              <p class="bhub-notif-card-body-text">{{ notif.body }}</p>

              <!-- Tags -->
              @if (notif.tags && notif.tags.length > 0) {
                <div class="bhub-notif-tags" aria-label="Tags">
                  @for (tag of notif.tags; track tag) {
                    <span class="bhub-notif-tag">{{ tag }}</span>
                  }
                </div>
              }

              <!-- Footer: meta + CTA -->
              <div class="bhub-notif-card-footer">
                <div class="bhub-notif-meta">
                  @if (notif.clientName) {
                    <span class="bhub-notif-client-name">{{ notif.clientName }}</span>
                    <span class="bhub-notif-meta-sep" aria-hidden="true">·</span>
                  }
                  <span
                    class="bhub-notif-time"
                    [pTooltip]="absoluteTime(notif.createdAt)"
                    tooltipPosition="bottom"
                    [attr.aria-label]="absoluteTime(notif.createdAt)"
                  >
                    {{ relativeTime(notif.createdAt) }}
                  </span>
                </div>

                @if (hasCta(notif)) {
                  <button
                    type="button"
                    class="bhub-notif-cta-btn"
                    (click)="onCta($event, notif.cta)"
                    [attr.aria-label]="notif.cta.label + ' for ' + notif.title"
                  >
                    {{ notif.cta.label }}
                    <i class="pi pi-arrow-right" aria-hidden="true"></i>
                  </button>
                }
              </div>
            </div>
          </div>
        }
      }
    </div>

    <!-- Footer -->
    <div class="bhub-notif-footer" aria-label="Notifications footer">
      <span class="bhub-notif-footer-note">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        Demo data only — notifications are not persisted
      </span>
    </div>

  </div>
</p-overlayPanel>
